import React from "react";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const CouponStats = ({ dashboardData }) => {
  const { t } = useTranslation();

  const mostUsedCoupon = dashboardData?.mostUsedCoupon;

  const data = [
    {
      label: t("coupon.totalCoupon", "Total Coupons"),
      value: dashboardData?.totalCoupons || 0,
    },
    {
      label: t("coupon.activeCoupon", "Active Coupons"),
      value: dashboardData?.activeCoupons || 0,
    },
    {
      label: t("coupon.mostUsedCoupon", "Most Used Coupon"),
      value: mostUsedCoupon ? (
        <>
          <div>{`${mostUsedCoupon?.name} (${mostUsedCoupon?.promocode})`}</div>
          <div
            style={{
              fontSize: "13px",
              color: "#666",
              marginTop: "2px",
            }}
          >
            {`Used ${mostUsedCoupon?.usedCount} times`}
          </div>
        </>
      ) : (
        "N/A"
      ),
      tooltip:
        mostUsedCoupon &&
        `Name: ${mostUsedCoupon?.name}\nPromocode: ${mostUsedCoupon?.promocode}\nUsed: ${mostUsedCoupon?.usedCount} times`,
    },
  ];

  return (
    <Row>
      {data.map((item, index) => (
        <Col key={index} lg={4} md={6} sm={12} className="my-2">
          <OverlayTrigger
            placement="top"
            overlay={
              item.tooltip ? (
                <Tooltip id={`tooltip-${index}`}>
                  <div style={{ whiteSpace: "pre-line" }}>{item.tooltip}</div>
                </Tooltip>
              ) : (
                <></>
              )
            }
          >
            <div
              className="cardCstm rounded p-3 d-flex flex-column justify-content-between"
              style={{
                background: "#ffe6f0",
                borderRadius: "10px",
                height: "100%", // equal height across all cards
                minHeight: "100px",
              }}
            >
              <div className="content">
                <h6
                  className="m-0 fw-bold text-secondary"
                  style={{ fontSize: "14px" }}
                >
                  {item.label}
                </h6>
                <div
                  className="fw-bold themeBlue py-1"
                  style={{ fontSize: "16px", lineHeight: "1.4" }}
                >
                  {item.value}
                </div>
              </div>
            </div>
          </OverlayTrigger>
        </Col>
      ))}
    </Row>
  );
};

export default CouponStats;
